"use client";
import { getSpacing } from "../../../../core/utils/get-size/get-size.mjs";
//#region packages/@mantine/core/src/components/AppShell/AppShellMediaStyles/get-padding-value/get-padding-value.ts
function getPaddingValue(padding) {
	return Number(padding) === 0 ? "0px" : getSpacing(padding);
}
//#endregion
export { getPaddingValue };

//# sourceMappingURL=get-padding-value.mjs.map